import React, { useState, useEffect } from 'react';
import { bookingsAPI } from '../utils/api';
import { toast } from 'react-toastify';
import CustomersTable from '../components/CustomersTable';
import ConfirmModal from '../components/ConfirmModal';

function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    customer: null,
    loading: false
  });

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await bookingsAPI.getAllCustomers();
      setCustomers(response.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = (customer) => {
    setDeleteModal({
      isOpen: true,
      customer,
      loading: false
    });
  };

  const handleConfirmDelete = async () => {
    if (!deleteModal.customer) return;

    setDeleteModal(prev => ({ ...prev, loading: true }));
    try {
      await bookingsAPI.deleteCustomer(deleteModal.customer.id);
      toast.success(`Customer "${deleteModal.customer.name}" deleted successfully`);
      setDeleteModal({ isOpen: false, customer: null, loading: false });
      fetchCustomers(); // Refresh the list
    } catch (error) {
      console.error('Error deleting customer:', error);
      toast.error(error.response?.data?.error || 'Failed to delete customer');
      setDeleteModal(prev => ({ ...prev, loading: false }));
    }
  };

  const handleCancelDelete = () => {
    setDeleteModal({ isOpen: false, customer: null, loading: false });
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading customers...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <h1 style={{ marginBottom: '1.5rem' }}>Customers</h1>
        <CustomersTable customers={customers} onDelete={handleDeleteClick} />
      </div>

      <ConfirmModal
        isOpen={deleteModal.isOpen}
        title="Delete Customer"
        message={
          deleteModal.customer
            ? `Are you sure you want to delete "${deleteModal.customer.name}" (${deleteModal.customer.email})?\n\nThis will permanently delete:\n• All their bookings\n• Payment records\n• Loyalty stamps\n• Messages\n\nThis action cannot be undone.`
            : ''
        }
        confirmText="Delete Customer"
        confirmStyle="danger"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        loading={deleteModal.loading}
      />
    </div>
  );
}

export default AdminCustomers;
